// Cuántos pedidos del catálogo (incluidas las compras digitales) están por
// confirmar, para mostrar un contador en el menú y que el vendedor esté
// pendiente. Una sola consulta compartida por todos los componentes que lo
// usan (el menú se dibuja dos veces: escritorio y celular), cada minuto.

import { useState, useEffect } from 'react';
import { getPedidos } from '../services/apiService';

const CADA_MS = 60 * 1000;

let cantidad = 0;
let suscriptores = new Set();
let temporizador = null;

const avisar = () => suscriptores.forEach((fn) => fn(cantidad));

// También se llama al confirmar o rechazar un pedido, para que el número baje al instante.
export const refrescarPedidosPendientes = async () => {
  try {
    const data = await getPedidos('PENDIENTE_REVISION', 1, 1);
    cantidad = data?.totalCount || 0;
    avisar();
  } catch (e) {
    // Sin conexión o sesión vencida: se conserva el último número, nunca se rompe el menú.
  }
};

export default function usePedidosPendientes() {
  const [n, setN] = useState(cantidad);

  useEffect(() => {
    suscriptores.add(setN);
    if (suscriptores.size === 1) {
      refrescarPedidosPendientes();
      temporizador = setInterval(refrescarPedidosPendientes, CADA_MS);
    } else {
      setN(cantidad);
    }
    return () => {
      suscriptores.delete(setN);
      if (suscriptores.size === 0 && temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    };
  }, []);

  return n;
}
